import { types, actions } from './requests'
export const CREATELISTING_TYPES = {
    ...types('CREATELISTING'),
}
export const CREATELISTING_ACTIONS = {
    ...actions('CREATELISTING'),
}